import React, { useEffect, useState, useRef } from "react";
import { AddCircleOutline, Delete, Edit, Visibility } from "@mui/icons-material";
import { Button, Tabs, Tab, IconButton, Tooltip } from "@mui/material";
import { Row, Col, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import "../../styles/styles.css";
import "../../styles/layout.css";
import TaskVeiwController from "../../redux/actions/TaskApiAction";
import AddTaskFormModal from "./AddTaskForm";
import TaskView from "./ViewTask";
import ProjectViewController from "../../redux/actions/ProjectApiAction";
import ReusableGrid from "../../components/ag grid/ReusableGrid";
import ExportButton from "../../components/ag grid/ExportButton";
import usePermission from "../../utils/usePermission";
import PageSizeSelector from "../../components/ag grid/PageSizeSelector";

const statusOptions = ["New", "Pending", "In Progress", "Completed"];
const priorityOptions = ["Low", "Medium", "High", "Critical"];

const statusColors = {
  New: "#2196F3",
  Pending: "#FF9800",
  "In Progress": "#9C27B0",
  Completed: "#4CAF50",
};

const priorityColors = {
  Low: "#8BC34A",
  Medium: "#FFC107",
  High: "#FF5722",
  Critical: "#F44336",
};

const TaskList = () => {
  const dispatch = useDispatch();
  const gridRef = useRef(null);

  const userType = localStorage.getItem("user_type");

  const [showModal, setShowModal] = useState(false);
  const [editTask, setEditTask] = useState(null);
  const [tabValue, setTabValue] = useState("Task");
  const [selectedTask, setSelectedTask] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedProjectId, setSelectedProjectId] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const { hasPermission } = usePermission();

  const { getProjects } = ProjectViewController();
  const { projects } = useSelector((state) => state.project);

  const { getTasks, updateTask, deleteTask } = TaskVeiwController();
  const { tasks } = useSelector((state) => state.task);


  useEffect(() => {
    dispatch(getProjects());
  }, [dispatch]);

  useEffect(() => {
    if (projects?.length > 0 && !selectedProjectId) {
      setSelectedProjectId(projects[0].id);
    }
  }, [projects, selectedProjectId]);

  useEffect(() => {
    if (selectedProjectId) {
      dispatch(getTasks(tabValue, selectedProjectId));
    }
  }, [dispatch, tabValue, selectedProjectId]);

  const handleProjectChange = (e) => {
    setSelectedProjectId(Number(e.target.value));
  };

  const handleDelete = (taskId) => {
    dispatch(deleteTask(taskId, tabValue, selectedProjectId));
  };

  const handleEdit = (task) => {
    setEditTask(task);
    setShowModal(true);
  };

  const openModalForCreate = () => {
    setEditTask(null);
    setShowModal(true);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleStatusChange = (taskId, value) => {
    dispatch(updateTask(taskId, { status: value }, tabValue, selectedProjectId));
  };

  const handlePriorityChange = (taskId, value) => {
    dispatch(updateTask(taskId, { priority: value }, tabValue, selectedProjectId));
  };

  const handleView = (task) => {
    setSelectedTask(task);
    setShowViewModal(true);
  };

  const handleSave = (projectId, category) => {
    dispatch(getTasks(category, projectId));
  };

  const selectedProject = projects.find((p) => p.id === selectedProjectId) || {};

  const columnDefs = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      maxWidth: 50,
      pinned: "left",
    },
    {
      headerName: "ID",
      valueGetter: (params) => params.node.rowIndex + 1,
      maxWidth: 80,
    },
    { headerName: "Title", field: "title", flex: 1 },
    {
      headerName: "Assigned To",
      field: "assigned_to",
      flex: 1,
      valueGetter: (params) =>
        `${params.data.assigned_to?.name || ""} `,
    },
    {
      headerName: "Created On",
      field: "created_at",
      flex: 1,
      valueGetter: (params) => new Date(params.data.created_at).toLocaleDateString(),
    },
 {
  headerName: "Priority",
  field: "priority",
  flex: 1,
  cellRenderer: (params) => (
    <Form.Select
      size="sm"
      value={params.value}
      onChange={(e) => handlePriorityChange(params.data.id, e.target.value)}
      style={{
        color: priorityColors[params.value] || "black",
        fontWeight: "bold",
        border: "none",           // remove border
        outline: "none",          // remove focus outline
        boxShadow: "none",        // remove focus shadow
        backgroundColor: "white",
        appearance: "none",       // remove default styling
        WebkitAppearance: "none",
        MozAppearance: "none",
        backgroundImage:
          "url('data:image/svg+xml;utf8,<svg fill=\"%23333\" height=\"10\" viewBox=\"0 0 10 10\" width=\"10\" xmlns=\"http://www.w3.org/2000/svg\"><polygon points=\"0,0 10,0 5,5\"/></svg>')",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "right 8px center",
        backgroundSize: "10px",
        cursor: "pointer",
        padding: "2px 24px 2px 4px", // space for arrow
      }}
      onFocus={(e) => e.target.blur()} // optional: prevent focus highlight entirely
    >
      {priorityOptions.map((option) => (
        <option key={option} value={option} style={{ color: priorityColors[option] }}>
          {option}
        </option>
      ))}
    </Form.Select>
  ),
},
    {
  headerName: "Status",
  field: "status",
  flex: 1,
  cellRenderer: (params) => (
    <Form.Select
      size="sm"
      value={params.value}
      onChange={(e) => handleStatusChange(params.data.id, e.target.value)}
      style={{
        color: statusColors[params.value] || "black",
        fontWeight: "bold",
        border: "none",            // remove border
        outline: "none",           // remove focus outline
        boxShadow: "none",         // remove focus shadow
        backgroundColor: "white",
        appearance: "none",        // remove default select styling
        WebkitAppearance: "none",
        MozAppearance: "none",
        backgroundImage:
          "url('data:image/svg+xml;utf8,<svg fill=\"%23333\" height=\"10\" viewBox=\"0 0 10 10\" width=\"10\" xmlns=\"http://www.w3.org/2000/svg\"><polygon points=\"0,0 10,0 5,5\"/></svg>')", // down arrow
        backgroundRepeat: "no-repeat",
        backgroundPosition: "right 8px center",
        backgroundSize: "10px",
        cursor: "pointer",
        padding: "2px 24px 2px 4px", // space for arrow
      }}
    >
      {statusOptions.map((option) => (
        <option
          key={option}
          value={option}
          style={{ color: statusColors[option] }}
        >
          {option}
        </option>
      ))}
    </Form.Select>
  ),
},

    {
      headerName: "Actions",
      field: "actions",
      minWidth: 150,
      cellRenderer: (params) => (
        <div className="d-flex justify-content-evenly">
          <Tooltip title="View">
            <IconButton onClick={() => handleView(params.data)} size="small">
              <Visibility />
            </IconButton>
          </Tooltip>
          {hasPermission("task_issues_management", "edit") &&(
          <Tooltip title="Edit">
            <IconButton onClick={() => handleEdit(params.data)} size="small">
              <Edit />
            </IconButton>
          </Tooltip>
          )}
          {hasPermission("task_issues_management", "delete") &&(
          <Tooltip title="Delete">
            <IconButton onClick={() => handleDelete(params.data.id)} size="small">
              <Delete sx={{ color: "#d32f2f" }} />
            </IconButton>
          </Tooltip>
          )}
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className="mb-3">
  <div className="row g-2 align-items-center">
    {/* Left side: Project Select + Add Button */}
    <div className="col-12 col-md-8">
      <div className="d-flex flex-wrap gap-2">
        {/* Select Project Dropdown */}
        <Form.Select
          style={{ width: "250px", height: "40px" }}
          value={selectedProjectId}
          onChange={handleProjectChange}
        >
          <option value="">-- Select Project --</option>
          {projects?.map((project) => (
            <option key={project.id} value={project.id}>
              {project.title}
            </option>
          ))}
        </Form.Select>

        {/* Add Button */}
        {hasPermission("task_issues_management", "create") && (
          <Button
            variant="contained"
            startIcon={<AddCircleOutline />}
            onClick={openModalForCreate}
            sx={{
              borderRadius: "8px",
              backgroundColor: "#1976d2",
              textTransform: "none",
              paddingX: 2,
              height: "40px",
              fontSize: "0.875rem",
            }}
          >
            Add Task/Issue
          </Button>
        )}
      </div>
    </div>

    {/* Right side: Export & Page Size */}
    <div className="col-12 col-md-4 d-flex justify-content-md-end gap-2">
      {selectedRows.length > 0 &&
        hasPermission("task_issues_management", "export") && (
          <ExportButton
            gridRef={gridRef}
            fileName="task_list.xlsx"
            exportColumns={["title", "assigned_to", "created_at", "priority", "status"]}
          />
        )}

      <PageSizeSelector
        pageSize={pageSize}
        onChange={(e) => setPageSize(Number(e.target.value))}
      />
    </div>
  </div>
</div>


      <div className="label-card">
        <Row className="justify-content-between w-100">
          <Col>
            {/* <h3>{tabValue === "Task" ? "Task" : "Issue Tracker"}</h3> */}
            <Tabs value={tabValue} onChange={handleTabChange} textColor="primary" indicatorColor="primary">
              <Tab label="Assigned Task" value="Task" />
              <Tab label="Issue Tracker" value="Issue" />
            </Tabs>
          </Col>
        </Row>
      </div>

      <div className="ag-theme-material" style={{ height: "70vh" }}>
        <ReusableGrid
          rowData={tasks}
          columnDefs={columnDefs}
          gridRef={gridRef}
          pagination={true}
          pageSize={pageSize}
          onSelectionChanged={(rows) => setSelectedRows(rows)}
        />
      </div>

      <AddTaskFormModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        initialData={editTask}
        selectedProject={selectedProject}
        category={tabValue}
        projectId={selectedProjectId}
        onSave={handleSave}
      />

      <TaskView
        show={showViewModal}
        handleClose={() => setShowViewModal(false)}
        selectedTask={selectedTask}
        category={tabValue}
      />
    </div>
  );
};

export default TaskList;





















// import React, { useEffect, useState } from "react";
// import { AddCircleOutline, Delete, Edit, Visibility } from "@mui/icons-material";
// import Table from "react-bootstrap/Table";
// import { Button, Tabs, Tab } from "@mui/material";
// import { Row, Col, Form } from "react-bootstrap";
// import { useDispatch, useSelector } from "react-redux";
// import "../../styles/styles.css";
// import "../../styles/layout.css";
// import TaskVeiwController from "../../redux/actions/TaskApiAction";
// import AddTaskFormModal from "./AddTaskForm";
// import TaskView from "./ViewTask";
// import ProjectViewController from "../../redux/actions/ProjectApiAction";

// const statusOptions = ["New", "Pending", "In Progress", "Completed"];
// const priorityOptions = ["Low", "Medium", "High", "Critical"];

// const statusColors = {
//   New: "#2196F3",
//   Pending: "#FF9800",
//   "In Progress": "#9C27B0",
//   Completed: "#4CAF50",
// };

// const priorityColors = {
//   Low: "#8BC34A",
//   Medium: "#FFC107",
//   High: "#FF5722",
//   Critical: "#F44336",
// };

// const TaskList = () => {
//   const dispatch = useDispatch();
//   const userType = localStorage.getItem("user_type");

//   const [showModal, setShowModal] = useState(false);
//   const [editTask, setEditTask] = useState(null);
//   const [tabValue, setTabValue] = useState("Task");
//   const [selectedTask, setSelectedTask] = useState(null);
//   const [showViewModal, setShowViewModal] = useState(false);
//   const [selectedProjectId, setSelectedProjectId] = useState("");

//   const { getProjects } = ProjectViewController();
//   const { projects } = useSelector((state) => state.project);

//   const { getTasks, updateTask, deleteTask } = TaskVeiwController();
//   const { tasks } = useSelector((state) => state.task);

//   // Load projects once
//   useEffect(() => {
//     dispatch(getProjects());
//   }, [dispatch]);

//   // When projects load or change, set the first project as default selected
//   useEffect(() => {
//     if (projects?.length > 0 && !selectedProjectId) {
//       setSelectedProjectId(projects[0].id);
//     }
//   }, [projects, selectedProjectId]);

//   // Fetch tasks when tabValue or selectedProjectId changes
//   useEffect(() => {
//     if (selectedProjectId) {
//       dispatch(getTasks(tabValue, selectedProjectId));
//     }
//   }, [dispatch, tabValue, selectedProjectId]);

//   const handleProjectChange = (e) => {
//     setSelectedProjectId(Number(e.target.value));
//   };
  

//   const handleDelete = (taskId) => {
//     dispatch(deleteTask(taskId, tabValue, selectedProjectId));  // Pass filters here
//   };

//   const handleEdit = (task) => {
//     setEditTask(task);
//     setShowModal(true);
//   };

//   const openModalForCreate = () => {
//     setEditTask(null);
//     setShowModal(true);
//   };

//   const handleTabChange = (event, newValue) => {
//     setTabValue(newValue);
//   };

//   const handleStatusChange = (taskId, value) => {
//     dispatch(updateTask(taskId, { status: value }, tabValue, selectedProjectId)); // Pass filters here
//   };

//   const handlePriorityChange = (taskId, value) => {
//     dispatch(updateTask(taskId, { priority: value }, tabValue, selectedProjectId)); // Pass filters here
//   };

//   const handleView = (task) => {
//     setSelectedTask(task);
//     setShowViewModal(true);
//   };

//   const handleSave = (projectId, category) => {
//     dispatch(getTasks(category, projectId));  // Your existing action that fetches filtered tasks
//   };
  

//   const selectedProject = projects.find(p => p.id === selectedProjectId) || {};


//   return (
//     <div>
//       <div className="d-flex justify-content-between align-items-center mb-3">
//         <Form.Select
//           style={{ width: "300px" }}
//           value={selectedProjectId}
//           onChange={handleProjectChange}
//         >
//           <option value="">-- Select Project --</option>
//           {projects?.map((project) => (
//             <option key={project.id} value={project.id}>
//               {project.title}
//             </option>
//           ))}
//         </Form.Select>

//         <Button
//           variant="contained"
//           startIcon={<AddCircleOutline />}
//           onClick={openModalForCreate}
//         >
//           Add Task/Issue
//         </Button>
//       </div>

//       <div>
//         <div className="label-card">
//           <Row className="justify-content-between w-100">
//             <Col>
//               <h3>{tabValue === "Task" ? "Task" : "Issue Tracker"}</h3>
//               <Tabs
//                 value={tabValue}
//                 onChange={handleTabChange}
//                 textColor="primary"
//                 indicatorColor="primary"
//               >
//                 <Tab label="Assigned Task" value="Task" />
//                 <Tab label="Issue Tracker" value="Issue" />
//               </Tabs>
//             </Col>
//           </Row>
//         </div>

//         <Table striped bordered hover responsive="sm">
//           <thead>
//             <tr>
//               <th>ID</th>
//               <th>Title</th>
//               <th>Assigned To</th>
//               <th>Created On</th>
//               <th>Priority</th>
//               <th>Status</th>
//               <th> Actions </th>
//             </tr>
//           </thead>
//           <tbody>
//             {tasks?.map((task, index) => (
//               <tr key={task.id} style={{ background: "#FAFAFA" }}>
//                 <td>{index + 1}</td>
//                 <td>{task.title}</td>
//                 <td>
//                   {task.assigned_to?.first_name} {task.assigned_to?.last_name}
//                 </td>
//                 <td>{new Date(task.created_at).toLocaleDateString()}</td>
//                 <td>
//                   <Form.Select
//                     value={task.priority}
//                     onChange={(e) =>
//                       handlePriorityChange(task.id, e.target.value)
//                     }
//                     style={{
//                       backgroundColor: "white",
//                       color:
//                         task.priority === "Low"
//                           ? "#8BC34A"
//                           : task.priority === "Medium"
//                           ? "#FFC107"
//                           : task.priority === "High"
//                           ? "#FF5722"
//                           : task.priority === "Critical"
//                           ? "#dc3545"
//                           : "black",
//                       fontWeight: "bold",
//                     }}
//                   >
//                     <option value="Low" style={{ color: "#8BC34A" }}>
//                       Low
//                     </option>
//                     <option value="Medium" style={{ color: "#FFC107" }}>
//                       Medium
//                     </option>
//                     <option value="High" style={{ color: "#FF5722" }}>
//                       High
//                     </option>
//                     <option value="Critical" style={{ color: "#F44336" }}>
//                       Critical
//                     </option>
//                   </Form.Select>
//                 </td>

//                 <td>
//                   <Form.Select
//                     value={task.status}
//                     onChange={(e) =>
//                       handleStatusChange(task.id, e.target.value)
//                     }
//                     style={{
//                       backgroundColor: "white",
//                       color:
//                         task.status === "New"
//                           ? "#2196F3"
//                           : task.status === "Pending"
//                           ? "#FF9800"
//                           : task.status === "In Progress"
//                           ? "#9C27B0"
//                           : task.status === "Completed"
//                           ? "#4CAF50"
//                           : "black",
//                       fontWeight: "bold",
//                     }}
//                   >
//                     <option value="New" style={{ color: "#2196F3" }}>
//                       New
//                     </option>
//                     <option value="Pending" style={{ color: "#FF9800" }}>
//                       Pending
//                     </option>
//                     <option value="In Progress" style={{ color: "#9C27B0" }}>
//                       In Progress
//                     </option>
//                     <option value="Completed" style={{ color: "#4CAF50" }}>
//                       Completed
//                     </option>
//                   </Form.Select>
//                 </td>

//                 <td>
//                   <div className="d-flex justify-content-evenly">
//                     <Visibility onClick={() => handleView(task)} />
//                     <Edit onClick={() => handleEdit(task)} />{" "}
//                     <Delete onClick={() => handleDelete(task.id)} />
//                   </div>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </Table>
//       </div>

//       <AddTaskFormModal
//         show={showModal}
//         handleClose={() => setShowModal(false)}
//         initialData={editTask}
//         selectedProject={selectedProject}
//         category={tabValue}                // Pass tabValue as category
//         projectId={selectedProjectId}   
//         onSave={handleSave}
//       />

//       <TaskView
//         show={showViewModal}
//         handleClose={() => setShowViewModal(false)}
//         selectedTask={selectedTask}
//         category={tabValue}
//       />
//     </div>
//   );
// };

// export default TaskList;
